var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedirectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5.5V20h-1V9h-55v31.5h55V27h1v14.5H.5V.5h57zm66 0v41h-57V27h1v13.5h55V9h-55v11h-1V.5h57zM73.354 15.646L80.707 23l-7.353 7.354-.708-.708 6.146-6.147L48 23.5v-1h30.792l-6.146-6.146.708-.708zM56.5 1.5h-55V8h55V1.5zm66 0h-55V8h55V1.5zm-117 3a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM71 4a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z",
    fill: "#646464",
    fillRule: "evenodd",
    opacity: 0.6
  })));
}

export default "data:image/svg+xml,%3Csvg width='124' height='42' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M57.5.5V20h-1V9h-55v31.5h55V27h1v14.5H.5V.5h57zm66 0v41h-57V27h1v13.5h55V9h-55v11h-1V.5h57zM73.354 15.646L80.707 23l-7.353 7.354-.708-.708 6.146-6.147L48 23.5v-1h30.792l-6.146-6.146.708-.708zM56.5 1.5h-55V8h55V1.5zm66 0h-55V8h55V1.5zm-117 3a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM71 4a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z' fill='%23646464' fill-rule='evenodd' opacity='.6'/%3E%3C/svg%3E";
export { SvgRedirectIcon as ReactComponent };